<template>
    <div>
        <card-header title="New Task" icon="fa-plus"/>

        <card-body>
            <card-list>
                <subheader-list-item icon="fa-align-left" title="Task Details"/>

                <container-list-item padded no-border>
                    <div class="columns">
                        <div class="column">
                            <b-field label-position="inside">
                                <template #label>Title <span class="required-flag">*</span></template>
                                <b-input v-model="form.title"></b-input>
                            </b-field>
                        </div>
                    </div>
                    <div class="columns">
                        <div class="column">
                            <b-field label="Description" label-position="inside">
                                <b-input type="textarea" v-model="form.description" rows="3"></b-input>
                            </b-field>
                        </div>
                    </div>
                </container-list-item>

                <subheader-list-item icon="fa-user" title="Assignment"/>

                <container-list-item padded no-border>
                    <div class="columns">
                        <div class="column">
                            <b-field label="Assign To" label-position="inside">
                                <b-select v-model="form.assigned_to" expanded>
                                    <option :value="null">Unassigned</option>
                                    <option v-for="pu in portalUsers" :key="pu.id" :value="pu.id">{{pu.first_name}} {{pu.last_name}}</option>
                                </b-select>
                            </b-field>
                        </div>
                        <div class="column">
                            <b-field label="Due Date" label-position="inside">
                                <b-input v-model="form.due_date" type="date"></b-input>
                            </b-field>
                        </div>
                    </div>
                </container-list-item>
            </card-list>
        </card-body>

        <card-footer class="pt-3 pb-3">
            <div class="columns">
                <div class="column has-text-right">
                    <b-button
                        type="is-primary"
                        size="is-small"
                        @click="submit"
                        :disabled="!form.title"
                    ><i class="fas fa-plus mr-2"></i>New Task
                    </b-button>
                </div>
            </div>
        </card-footer>
    </div>
</template>

<script>
    import CardHeader from "@/TIER/components/CardHeader";
    import CardBody from "@/TIER/components/CardBody";
    import CardList from "@/TIER/components/CardList";
    import CardFooter from "@/components/common/CardFooter";
    import SubheaderListItem from "@/TIER/components/SubheaderListItem";
    import ContainerListItem from "@/TIER/components/ContainerListItem";
    import {client as http} from '@/http_client';

    export default {
        components: {ContainerListItem, SubheaderListItem, CardList, CardFooter, CardBody, CardHeader},
        props: ['card', 'props'],
        data() {
            return {
                form: {
                    title: '',
                    description: '',
                    assigned_to: null,
                    due_date: null
                },
                portalUsers: []
            }
        },
        methods: {
            loadPortalUsers() {
                http.get('portal-users').then(response => {
                    this.portalUsers = response.data || [];
                }).catch(() => {});
            },
            submit() {
                if (!this.form.title.trim()) return;
                this.$emit('loading', true);
                http.post('support/tasks', this.form).then(() => {
                    this.$emit('loading', false);
                    this.$closeCard(this.card);
                }).catch(err => {
                    window.alert(err.response?.data?.message || 'An error occurred.');
                    this.$emit('loading', false);
                });
            }
        },
        mounted() {
            this.loadPortalUsers();
        }
    }
</script>
